// extracted by mini-css-extract-plugin
export const button = "back-to-top-module--button--13jER";
export const active = "back-to-top-module--active--2yMRY";